module.exports = __webpack_public_path__ + "static/media/wordpress-filled.4c7f830e.svg";